/* Search sheet for phones and tablets (2026-10-08). Markup and styles: snippets/so-search-sheet.liquid.
   Results: sections/so-search-results.liquid through the Section Rendering API. */
(function () {
  if (window.__soSearchSheet) return;
  window.__soSearchSheet = true;

  var sheet = document.getElementById('so-search-sheet');
  if (!sheet) return;
  document.body.appendChild(sheet);

  var mq = window.matchMedia('(max-width: 1149px)');
  var panel = sheet.querySelector('.so-ss__panel');
  var input = sheet.querySelector('[data-so-ss-input]');
  var clear = sheet.querySelector('[data-so-ss-clear]');
  var idle = sheet.querySelector('[data-so-ss-idle]');
  var results = sheet.querySelector('[data-so-ss-results]');
  var body = sheet.querySelector('[data-so-ss-body]');
  var toast = sheet.querySelector('[data-so-ss-toast]');
  var root = sheet.getAttribute('data-root') || '/';
  if (root.slice(-1) !== '/') root += '/';
  var lastFocus = null, timer = 0, ctrl = null, lastQ = '', toastT = 0;

  /* ---------- open / close ---------- */
  function open() {
    if (!sheet.hidden) return;
    lastFocus = document.activeElement;
    // Suggested rows ship inert in a <template>; make them real before anything else reads the sheet.
    Array.prototype.forEach.call(sheet.querySelectorAll('template[data-so-defer]'), function (t) { t.replaceWith(t.content); });
    // The suggestions sit in a hidden sheet, so lazy images never started; load them now.
    Array.prototype.forEach.call(sheet.querySelectorAll('img[loading="lazy"]'), function (i) { i.loading = 'eager'; });
    sheet.hidden = false;
    loadIndex();
    document.documentElement.classList.add('so-ss-lock');
    lift();
    // Focus inside the same task as the tap, so iOS raises the keyboard.
    input.focus({ preventScroll: true });
    requestAnimationFrame(function () { sheet.classList.add('is-open'); });
    window.setTimeout(function () { sheet.classList.add('is-open'); }, 30);
  }
  function close() {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    input.blur();
    document.documentElement.classList.remove('so-ss-lock');
    window.setTimeout(function () {
      sheet.hidden = true;
      panel.style.removeProperty('--so-drag');
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }, 380);
  }

  // Header field and toolbar search link open the sheet on touch-size screens.
  function isOpener(t) {
    return t.closest && (t.closest('.hdt_predictive-search2 [data-input-search]') || t.closest('[aria-controls="drawer-search-form"]') || t.closest('a.hdt-toolbar-item-btn[href$="/search"]'));
  }
  document.addEventListener('pointerdown', function (e) {
    if (!mq.matches || !isOpener(e.target)) return;
    if (e.target.closest('[data-input-search]')) e.preventDefault(); // no focus, so no theme dropdown
  }, true);
  document.addEventListener('click', function (e) {
    if (!mq.matches || !isOpener(e.target)) return;
    e.preventDefault();
    e.stopPropagation();
    open();
  }, true);
  document.addEventListener('focusin', function (e) {
    if (!mq.matches || !e.target.closest || !e.target.closest('.hdt_predictive-search2 [data-input-search]')) return;
    e.target.blur();
    open();
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });
  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-so-ss-close]')) close();
  });

  /* ---------- drag the top bar down to close ---------- */
  var dragY = 0, dragging = false, startY = 0, startT = 0;
  sheet.querySelector('[data-so-ss-drag]').addEventListener('pointerdown', function (e) {
    if (e.target.closest('input, button')) return;
    dragging = true; startY = e.clientY; startT = Date.now(); dragY = 0;
    sheet.classList.add('is-dragging');
  });
  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    dragY = Math.max(0, e.clientY - startY);
    panel.style.setProperty('--so-drag', dragY + 'px');
  }, { passive: true });
  function endDrag() {
    if (!dragging) return;
    dragging = false;
    sheet.classList.remove('is-dragging');
    var fast = dragY / Math.max(1, Date.now() - startT) > 0.5;
    if (dragY > panel.offsetHeight * 0.22 || (fast && dragY > 30)) close();
    else panel.style.setProperty('--so-drag', '0px');
  }
  window.addEventListener('pointerup', endDrag);
  window.addEventListener('pointercancel', endDrag);

  /* ---------- keyboard: lift the sheet by the keyboard's height ---------- */
  var vv = window.visualViewport;
  function lift() {
    if (!vv) return;
    var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
    if (kb < 80) kb = 0;
    sheet.style.setProperty('--so-kb', kb + 'px');
    sheet.style.setProperty('--so-vvh', Math.round(vv.height) + 'px');
  }
  if (vv) { vv.addEventListener('resize', lift); vv.addEventListener('scroll', lift); }

  /* ---------- the index: whole catalogue, matched on the phone ---------- */
  // sections/so-search-index.liquid, fetched once per session per language. Matching
  // runs on every keystroke with no network, and tolerates typos: "ica tlk" finds
  // Ice Talk. The server search below is only the fallback if the index fails.
  var IDX_KEY = 'so-ss-idx-v2:' + root;
  var index = null, indexP = null;
  function norm(s) {
    return String(s || '').toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[^0-9a-z؀-ۿ]+/g, ' ').trim();
  }
  function toks(s) { var n = norm(s); return n ? n.split(' ') : []; }
  function prep(list) {
    return list.map(function (p) {
      var f = [];
      var tt = toks(p.t);
      tt.forEach(function (w, k) {
        f.push([w, 1]);
        // Two words typed as one: "icetalk" for Ice Talk, "coconutwater".
        // Exact or starting matches only: fuzzy on a joined pair invents lookalikes
        // (water + coconut in Arabic is one letter from mango).
        if (tt[k + 1]) f.push([w + tt[k + 1], 0.95, 1]);
      });
      toks(p.v).forEach(function (w) { f.push([w, 0.95]); });
      toks(p.h).forEach(function (w) { f.push([w, 0.9]); });
      toks(p.y).forEach(function (w) { f.push([w, 0.6]); });
      toks(p.g).forEach(function (w) { f.push([w, 0.5]); });
      p._w = f;
      return p;
    });
  }
  function loadIndex() {
    if (indexP) return indexP;
    try {
      var c = JSON.parse(sessionStorage.getItem(IDX_KEY) || 'null');
      if (c && Date.now() - c.at < 20 * 60 * 1000 && c.list && c.list.length) { index = prep(c.list); return (indexP = Promise.resolve(index)); }
    } catch (e) {}
    indexP = fetch(root + 'collections/all?section_id=so-search-index', { headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" id="so-ss-index">([\s\S]*?)<\/script>/);
        var list = JSON.parse(m[1]);
        try { sessionStorage.setItem(IDX_KEY, JSON.stringify({ at: Date.now(), list: list })); } catch (e) {}
        index = prep(list);
        return index;
      })
      .catch(function () { indexP = null; return null; });
    return indexP;
  }
  // Optimal string alignment distance, capped: swapping two letters counts as one.
  function dist(a, b, cap) {
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > cap) return cap + 1;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur = [i]; var best = i;
      for (j = 1; j <= lb; j++) {
        var cost = a[i - 1] === b[j - 1] ? 0 : 1;
        var v = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (prev2 && i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < best) best = v;
      }
      if (best > cap) return cap + 1;
      prev2 = prev; prev = cur;
    }
    return prev[lb];
  }
  function tokScore(q, w, exactOnly) {
    if (w === q) return 1;
    if (w.indexOf(q) === 0) return 0.92;
    if (exactOnly) return 0;
    var L = q.length;
    if (L >= 3 && w.indexOf(q) > 0) return 0.7;
    if (L < 3 || /^\d+$/.test(q)) return 0;
    var cap = L <= 5 ? 1 : 2, d = dist(q, w, cap);
    // Still typing: compare against the start of the word too ("chocol" vs "chocolate").
    if (d > cap && w.length > L) d = Math.min(dist(q, w.slice(0, L), cap), dist(q, w.slice(0, L + 1), cap));
    return d <= cap ? 0.78 - 0.16 * d : 0;
  }
  function match(q) {
    var qt = toks(q);
    if (!qt.length || !index) return [];
    var out = [];
    index.forEach(function (p) {
      var sum = 0, hit = 0;
      qt.forEach(function (t) {
        var best = 0;
        for (var k = 0; k < p._w.length; k++) {
          var s = tokScore(t, p._w[k][0], p._w[k][2]) * p._w[k][1];
          if (s > best) { best = s; if (best >= 1) break; }
        }
        if (best > 0) hit++;
        sum += best;
      });
      // Every word should match; a long query may miss one and still rank, lower.
      var need = qt.length <= 2 ? qt.length : qt.length - 1;
      if (hit >= need && sum > 0) out.push({ p: p, s: sum / qt.length + (hit === qt.length ? 0.5 : 0) + (p.a ? 0.05 : 0) });
    });
    out.sort(function (a, b) { return b.s - a.s || a.p.t.length - b.p.t.length; });
    // With strong answers on the list, drop the loose lookalikes far below them.
    var top = out.length ? out[0].s : 0;
    return out.filter(function (x) { return x.s >= top * 0.62; }).map(function (x) { return x.p; });
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  var TX = {
    add: sheet.getAttribute('data-t-add') || 'Add to cart',
    sold: sheet.getAttribute('data-t-sold') || 'Sold out',
    results: sheet.getAttribute('data-t-results') || '__N__ results',
    all: sheet.getAttribute('data-t-all') || 'See all results',
    none: sheet.getAttribute('data-t-none') || 'No results for __Q__',
    tip: sheet.getAttribute('data-t-tip') || ''
  };
  var PLUS = '<svg class="so-ss-i-plus" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="M8 2.5v11M2.5 8h11" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg><svg class="so-ss-i-check" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true"><path d="m3.2 8.4 3 3 6.6-6.8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CHEV = '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="m6 3 5 5-5 5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  function row(p, k) {
    return '<li class="so-ss-row' + (p.a ? '' : ' is-soldout') + '"><a class="so-ss-row__link" href="' + esc(p.u) + '">' +
      '<span class="so-ss-row__img">' + (p.m ? '<img src="' + esc(p.m) + '" alt="" loading="' + (k < 8 ? 'eager' : 'lazy') + '" width="64" height="64">' : '') + '</span>' +
      '<span class="so-ss-row__info"><span class="so-ss-row__title">' + esc(p.t) + '</span><span class="so-ss-row__price">' +
      (p.a ? '<span class="hdt-money">' + esc(p.p) + '</span>' + (p.c ? '<s class="hdt-money">' + esc(p.c) + '</s>' : '') : '<span class="so-ss-row__out">' + esc(TX.sold) + '</span>') +
      '</span></span></a>' +
      (p.i ? '<span class="so-ss-row__slot" data-so-ss-v="' + p.i + '" data-t="' + esc(p.t) + '"><button type="button" class="so-ss-row__add" data-so-ss-add="' + p.i + '" aria-label="' + esc(TX.add + ': ' + p.t) + '">' + PLUS + '</button></span>'
           : '<a class="so-ss-row__go" href="' + esc(p.u) + '" tabindex="-1" aria-hidden="true">' + CHEV + '</a>') + '</li>';
  }
  function renderLocal(q) {
    var found = match(q), shown = found.slice(0, 30), html;
    if (!found.length) {
      html = '<div class="so-ss-empty"><svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.3-4.3"/></svg>' +
        '<p class="so-ss-empty__t">' + esc(TX.none).replace('__Q__', '<bdi>' + esc(q) + '</bdi>') + '</p><p class="so-ss-empty__s">' + esc(TX.tip) + '</p></div>';
    } else {
      html = '<p class="so-ss-label">' + esc(TX.results.replace('__N__', found.length)) + '</p><ul class="so-ss-list" role="list">' + shown.map(row).join('') + '</ul>' +
        '<a class="so-ss-all" href="' + esc(root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last') + '">' + esc(TX.all) + CHEV + '</a>';
    }
    results.innerHTML = '<div class="so-ss-results">' + html + '</div>';
    idle.hidden = true; results.hidden = false;
    body.scrollTop = 0;
    sheet.classList.remove('is-loading');
  }

  /* ---------- server results: fallback when the index is unavailable ---------- */
  function showIdle() {
    results.hidden = true; idle.hidden = false; results.innerHTML = '';
    sheet.classList.remove('is-loading');
  }
  function search(q) {
    if (ctrl) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    sheet.classList.add('is-loading');
    var url = root + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=so-search-results';
    fetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (q !== lastQ) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('.so-ss-results');
        results.innerHTML = box ? box.outerHTML : '';
        idle.hidden = true; results.hidden = false;
        body.scrollTop = 0;
        sheet.classList.remove('is-loading');
      })
      .catch(function (e) { if (!e || e.name !== 'AbortError') sheet.classList.remove('is-loading'); });
  }
  input.addEventListener('input', function () {
    var q = input.value.trim();
    clear.hidden = !input.value;
    lastQ = q;
    window.clearTimeout(timer);
    if (!q) { if (ctrl) ctrl.abort(); showIdle(); return; }
    if (index) { renderLocal(q); return; }
    sheet.classList.add('is-loading');
    loadIndex().then(function (ix) {
      if (q !== lastQ) return;
      if (ix) renderLocal(q);
      else timer = window.setTimeout(function () { search(q); }, 120);
    });
  });
  clear.addEventListener('click', function () {
    input.value = ''; clear.hidden = true; lastQ = ''; showIdle(); input.focus();
  });
  sheet.querySelector('[data-so-ss-form]').addEventListener('submit', function (e) {
    if (!input.value.trim()) e.preventDefault();
  });
  // Scrolling the list puts the keyboard away, as iOS lists do.
  body.addEventListener('touchmove', function () { if (document.activeElement === input) input.blur(); }, { passive: true });

  /* ---------- + adds to the cart in place ---------- */
  function say(text) {
    toast.textContent = text; toast.hidden = false;
    window.clearTimeout(toastT);
    toastT = window.setTimeout(function () { toast.hidden = true; }, 1800);
  }
  sheet.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-so-ss-add]');
    if (!btn || btn.classList.contains('is-busy')) return;
    e.preventDefault();
    btn.classList.remove('is-error', 'is-added');
    btn.classList.add('is-busy');
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-so-ss-add')), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-added');
        say(sheet.getAttribute('data-added'));
        window.setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('so:cart', { bubbles: true }));
      })
      .catch(function (err) {
        btn.classList.remove('is-busy'); btn.classList.add('is-error');
        say((err && err.description) || sheet.getAttribute('data-add-fail'));
        window.setTimeout(function () { btn.classList.remove('is-error'); }, 1600);
      });
  });

  // Leaving touch size with the sheet open hands the page back.
  (mq.addEventListener ? mq.addEventListener.bind(mq, 'change') : mq.addListener.bind(mq))(function () { if (!mq.matches) close(); });
})();
